import { apiClient } from '../apiClient';
import type { ILead } from '../types/lead';

interface ILeadProps {
    id: number;
}

export const resetLead = async ({ id }: ILeadProps) => {
    const response = await apiClient.post(`property-leads/${id}/reset`, {});
    return (await response.json()) as ILead;
};
